export enum DatePeriodModel {
    ThisWeek,
    ThisMonth, 
    ThisYear,
    PreviousYear,
    Custom
}